import React from 'react'
import {Snackbar,SnackbarContent} from '@material-ui/core/';

function Message(props) {

    const [state] = React.useState({
        open: true,
        vertical: 'bottom',
        horizontal: 'center',
      });
    
      const { vertical, horizontal } = state;


    return (

        <Snackbar 
        open={props.open}
        style={{ borderRadius : '1rem' }}
        anchorOrigin={{ vertical, horizontal }}
        key={vertical + horizontal}
        >
        <SnackbarContent style={{
              backgroundColor:'#007a00',         
        }}
        message="Successfully Registered as Vendor ! Please wait Redirecting..."
        />
        
        </Snackbar>

    )
}

export default Message
